import { Link } from "react-router-dom";

export default function PageNotFound() {
  return <section role="status" className="mx-auto max-w-xl space-y-4 px-6 py-12" data-testid="page-not-found">
    <h1 className="text-2xl font-semibold">Page not found</h1>
    <p>This address is not available. Choose a page from navigation or return below.</p>
    <div className="flex flex-wrap gap-4"><Link to="/app" className="underline">Dashboard</Link><Link to="/app/workspaces" className="underline">Workspaces</Link><Link to="/" className="underline">Home</Link></div>
  </section>;
}
